import type {
  ITextReplaceRule,
  EditorPerformanceResult,
} from '@carboncopyco/types';
import { TextCaption } from '@carboncopyco/ui';
import { useEditorFindAndReplaceRules } from '../../context/EditorSdkProvider';

interface Props {
  prevPerformanceResults: EditorPerformanceResult;
  performanceResults: EditorPerformanceResult;
  findAndReplaceAmount: number;
}

export const usePerformanceFindAndReplace = ({
  prevPerformanceResults,
  performanceResults,
  findAndReplaceAmount,
}: Props) => {
  const { createFindAndReplaceRule } = useEditorFindAndReplaceRules();

  const createRuleHandler = async (rule: Omit<ITextReplaceRule, 'ruleId'>) => {
    for (let index = 0; index < findAndReplaceAmount; index++) {
      const ruleIndex = {
        ...rule,
        oldValue: rule.oldValue + (index + 1),
        newValue: rule.newValue + (index + 1),
      };

      await createFindAndReplaceRule(ruleIndex);
    }
    return null;
  };

  const compareToPrev = <T extends keyof EditorPerformanceResult>(
    key: T,
    subkey: keyof EditorPerformanceResult[T],
    appendMs = true
  ) => {
    try {
      if (prevPerformanceResults[key][subkey] === 0) return null;

      const result =
        Number(prevPerformanceResults[key][subkey]) -
        Number(performanceResults[key][subkey]);

      return (
        <TextCaption
          label={` (${result > 0 ? '+' : ''}${result.toFixed(2)}${appendMs ? 'ms' : ''})`}
          color={
            result > 0
              ? 'text-ds-accent2-500'
              : result === 0
                ? 'text-ds-natural'
                : 'text-ds-danger'
          }
        />
      );
    } catch (e) {
      //
    }
  };

  return {
    compareToPrev,
    createRuleHandler,
  };
};
